import {createRouter, createWebHashHistory} from "vue-router";
import {apiStore} from "./stores/api";
import Login from "@/views/account/Login.vue";
import ResetPassword from "@/views/account/ResetPassword.vue";
import SalesAdmin from "@/views/sales/SalesAdmin.vue";
import AccountSettings from "@/views/account/AccountSettings.vue";
import ShopAdmin from "@/views/admin/ShopAdmin.vue";
import ServiceUsersAdmin from "@/views/admin/ServiceUsersAdmin.vue";
import ShopSettings from "@/views/admin/ShopSettings.vue";
import AppointmentList from "@/views/appointment/AppointmentList.vue";
import AppointmentEdit from "@/views/appointment/AppointmentEdit.vue";
import AppointmentStaff from "@/views/appointment/AppointmentStaff.vue";
import AppointmentMenu from "@/views/appointment/AppointmentMenu.vue";
import AppointmentType from "@/views/appointment/AppointmentType.vue";
import AppointmentSchedule from "@/views/appointment/AppointmentSchedule.vue";
import AppointmentListCompleted from "@/views/appointment/AppointmentListCompleted.vue";
import AppointmentResult from "@/views/appointment/AppointmentResult.vue";
import ClientSearch from "@/views/client/ClientSearch.vue";
import ClientSearchQR from "@/views/client/ClientSearchQR.vue";
import ClientSearchForm from "@/views/client/ClientSearchForm.vue";
import ClientSearchResult from "@/views/client/ClientSearchResult.vue";
import ClientDetail from "@/views/client/ClientDetail.vue";
import ClientEmailDetail from "@/views/client/ClientEmailDetail.vue";
import ClientReschedule from "@/views/client/ClientReschedule.vue";
import CoconList from "@/views/CoconList.vue";
import DemoBeds from "@/views/demo-beds/DemoBeds.vue";
import DemoBedAppointmentList from "@/views/demo-beds/DemoBedAppointmentList.vue";
import DemoBedDetail from "@/views/demo-beds/DemoBedDetail.vue";
import PageNotFound from "@/views/PageNotFound.vue";

const routes = [
    {
        path: "/login",
        component: Login,
        name: "login",
        meta: {
            title: "Login"
        }
    },
    {
        path: "/reset-password",
        component: ResetPassword,
        name: "reset-password",
        meta: {
            title: "reset-password"
        }
    },
    {
        path: "/shop/settings",
        component: ShopSettings,
        name: "shop-settings",
        meta: {
            title: "Shop Settings",
            requireLoggedinUser: true
        }
    },
    {
        path: "/sales/admin",
        component: SalesAdmin,
        name: "sales-admin",
        meta: {
            title: "Sales Admin",
            requireLoggedinUser: true
        }
    },
    {
        path: "/account/settings",
        component: AccountSettings,
        name: "account-settings",
        meta: {
            title: "Account Settings",
            requireLoggedinUser: true
        }
    },
    {
        path: "/",
        component: AppointmentList,
        name: "appointment-list",
        meta: {
            title: "AppointmentList",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointments",
        component: AppointmentMenu,
        name: "appointment-menu",
        meta: {
            title: "AppointmentMenu",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointment-type/:id?/:nextRoute?",
        component: AppointmentType,
        name: "appointment-type",
        meta: {
            title: "AppointmentType",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointments/edit/:id?",
        component: AppointmentEdit,
        name: "appointment-edit",
        meta: {
            title: "edit appointment",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointment-staff",
        component: AppointmentStaff,
        name: "appointment-staff",
        meta: {
            title: "staff appointment",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointments/schedule/:id",
        component: AppointmentSchedule,
        name: "appointment-schedule",
        meta: {
            title: "schedule appointment",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointment-list-completed",
        component: AppointmentListCompleted,
        name: "appointment-list-completed",
        meta: {
            title: "AppointmentListCompleted",
            requireLoggedinUser: true
        }
    },
    {
        path: "/appointment-result/:appointment_id",
        component: AppointmentResult,
        name: "appointment-result",
        meta: {
            title: "AppointmentResult",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-search",
        component: ClientSearch,
        name: "client-search",
        meta: {
            title: "client seach",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-search-form",
        component: ClientSearchForm,
        name: "client-search-form",
        meta: {
            title: "client seach",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-search-qr",
        component: ClientSearchQR,
        name: "client-search-qr",
        meta: {
            title: "client seach qr",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-search-result",
        component: ClientSearchResult,
        // pass clients object as props to the component
        props: (route) => ({clients: route.query.clients}),
        name: "client-search-result",
        meta: {
            title: "client seach result",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-detail/:ergosleep_id",
        component: ClientDetail,
        name: "client-detail",
        meta: {
            title: "client detail",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-email-detail/:ergosleep_id",
        component: ClientEmailDetail,
        name: "client-email-detail",
        meta: {
            title: "ClientEmailDetail",
            requireLoggedinUser: true
        }
    },
    {
        path: "/client-reschedule/:ergosleep_id",
        component: ClientReschedule,
        name: "client-reschedule",
        meta: {
            title: "ClientReschedule",
            requireLoggedinUser: true
        }
    },
    {
        path: "/cocons",
        component: CoconList,
        name: "cocons",
        meta: {
            title: "cocons",
            requireLoggedinUser: true
        }
    },
    {
        path: "/shop-admin",
        component: ShopAdmin,
        name: "shop-admin",
        meta: {
            title: "ShopAdmin",
            requireLoggedinUser: true
        }
    },
    {
        path: "/service-users",
        component: ServiceUsersAdmin,
        name: "service-users",
        meta: {
            title: "ServiceUsersAdmin",
            requireLoggedinUser: true
        }
    },
    {
        path: "/demo-beds",
        component: DemoBeds,
        name: "demo-beds",
        meta: {
            title: "DemoBeds",
            requireLoggedinUser: true
        }
    },
    {
        path: "/demo-beds-appointments",
        component: DemoBedAppointmentList,
        name: "demo-beds-appointments",
        meta: {
            title: "DemoBedAppointmentList",
            requireLoggedinUser: true,
            demoBedStatus: true
        }
    },
    {
        path: "/demo-beds-detail/:appointmentId",
        component: DemoBedDetail,
        name: "demo-beds-detail",
        meta: {
            title: "DemoBedDetail",
            requireLoggedinUser: true,
            demoBedStatus: true
        }
    },
    {
        path: "/:pathMatch(.*)*",
        component: PageNotFound
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to) => {
    const route = routes.find(x => x.name === to.name);
    if (route.meta.requireLoggedinUser === true && !apiStore().loggedInUser) {
        return {name: "login"};
    }
});

export default router;
